// extracted by mini-css-extract-plugin
export default {"avatar":"TablePerson_avatar__ZEGDc","avatar_small":"TablePerson_avatar_small__weVrL","avatar_large":"TablePerson_avatar_large__wtd7V"};